import angular from 'angular';

import '../../../services/user';
import events from "../../../services/events";


angular.module('folkeuni').component('login', {
  templateUrl: '/shop-dist/templates/login.html?c=' + window.cacheBurst,
  transclude: false,
  bindings: {
    departmentId: '@',
    newPasswordUrl: '@',
    myPageUrl: '@',
    userCreateUrl:'@'
  },
  controller: function(User) {
    var $ctrl = this;
    $ctrl.email = null;
    $ctrl.password = null;
    $ctrl.loading = false;

    $ctrl.login = function() {
      $ctrl.loading = true;
      $ctrl.errorMsg = null;
      var loginObj = {
        siteId: Number($ctrl.departmentId),
        email: $ctrl.email,
        password: $ctrl.password
      }

      User.login(loginObj).then(function(loginResponse) {
        var params = {};

        if (location.search) {
            var parts = location.search.substring(1).split('&');

            for (var i = 0; i < parts.length; i++) {
                var nv = parts[i].split('=');
                if (!nv[0]) continue;
                params[nv[0]] = nv[1] || true;
            }
        }
        var referrer = document.referrer ? new URL(document.referrer) : {};
        if (referrer.pathname && $ctrl.myPageUrl != referrer.pathname) {
            events.createModal({
                headline: "Du er nu logget ind",
                content: "Du er nu logget ind og kan fortsætte hvor du slap.",
                actions: [
                    {
                        label: "Min side",
                        href: $ctrl.myPageUrl
                    },
                    {
                        label: "Fortsæt",
                        href: referrer.pathname + referrer.search
                    }
                ],
                close: () => {
                  console.log("Modal closed");
                  window.location.href = params.fromUrl || $ctrl.myPageUrl;
                }
            });
        } else {
            var returnUrl = params.fromUrl || $ctrl.myPageUrl;
            window.location.href = returnUrl;
        }
      }, function(errorResponse) {
        if (errorResponse.status == 404) {
          $ctrl.errorMsg = "Emailen blev ikke genkendt.";
        } else if (errorResponse.status == 409) {
          $ctrl.errorMsg = "Bruger er ikke aktiveret, tjek venligst din e-mail efter aktiveringsmail.";
        } else if (errorResponse.status == 400) {
          $ctrl.errorMsg = "Password matchede ikke email.";
        } else {
          $ctrl.errorMsg = "Der skete en fejl, indtast venligst brugernavn og password igen.";
        }
        $ctrl.loading = false;
        console.log("Error",errorResponse);
      });
    }

    $ctrl.$onInit = function() {
      $ctrl.loginUrl = $ctrl.newPasswordUrl;
    };
  }
});
